import _sfc_main from "./component-library149.mjs";
import "./component-library150.mjs";
import normalizeComponent from "./component-library91.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  _vm._self._setupProxy;
  return _c("div", { staticClass: "product-offer-color-select" }, [_c("span", { staticClass: "product-offer-color-select__label" }, [_vm._v("Farben")]), _c("ColorSelector", { staticClass: "product-offer-color-select__list", attrs: { "variants": _vm.offerColorVariants, "value": _vm.value, "circle": "", "no-title": _vm.noTitle }, on: { "input": (args) => _vm.$emit("input", args) } })], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "a63c3689",
  null,
  null
);
const ProductOfferColorSelect = __component__.exports;
export {
  ProductOfferColorSelect as default
};
